import React, { useContext, useEffect, useState } from "react";
import "./Scan.css";
import { Button } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { LoadingContext } from "../../context/LoadingContext";
import { TitleContext } from "../../context/TitleContext";
import { routeNames } from "../../constants/routeNames";
import uploadIcon from "../../assets/images/icons/upload.svg";
import loadingGif from "../../assets/images/loading.gif";
import { errorHandler } from "../../helpers/errorHelper";
import Api from "../../api/Api";
import { ErrorTypes } from "../../constants/ErrorTypes";
export const Scan = (props) => {
  const { setTitle } = useContext(TitleContext);
  const { setLoading } = useContext(LoadingContext);
  const params = useParams();
  const [image, setImage] = useState(uploadIcon);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [showUploadBox, setShowUploadBox] = useState(true);
  const [recognition, setRecognition] = useState(true);
  const [checkWinner, setCheckWinner] = useState(false);
  const [user, setUser] = useState({});

  const navigate = useNavigate();

  useEffect(() => {
    setTitle("Scan your coca-Cola now");
    Api.checkUser(params.id).then((res) => {
      if (res && res?.result && res?.data) {
        if (res?.data?.winner && res?.data?.prize) {
          navigate(routeNames.WINNER, {
            state: {
              prize: res?.data?.prize,
              uniqueCode: res?.data?.uniqueCode,
              redirected: true,
            },
          });
        }
        setUser(res?.data);
        setLoading(false);
      } else {
        errorHandler(res, navigate);
      }
    });
  }, []);

  const submitForm = async () => {
    setCheckWinner(true);
    setTitle("");
    const data = { ...user };
    data.url = image;
    const response = await Api.validate(data);
    if (response && response?.result && response?.data) {
      navigate(routeNames.WINNER, {
        state: {
          prize: response?.data?.prize,
          uniqueCode: response?.data?.uniqueCode,
          redirected: true,
        },
      });
    } else if (response?.error) {
      if (response?.error?.type === ErrorTypes.RECOGNITION_FAILED) {
        setRecognition(false);
        setShowUploadBox(true);
        setTitle("SORRY");
        setCheckWinner(false);
      } else {
        errorHandler(response, navigate);
      }
    }
  };

  const onFileUpload = (e) => {
    setUploadLoading(true);
    const file = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = async function () {
      const fileObject = {
        name: file.name,
        mimeType: file.type,
        fileContent: reader.result.split(",")[1],
      };
      const response = await Api.uploadImage(fileObject);
      if (response && response?.data) {
        setImage(response?.data);
        setShowUploadBox(false);
        setTitle("Confirmation");
        setUploadLoading(false);
      }
    };
  };

  const removeUploaded = () => {
    setTitle("Scan your coca-Cola now");
    setImage(uploadIcon);
    setShowUploadBox(true);
  };

  useEffect(() => {
    if (uploadLoading) {
      setTitle("PLEASE WAIT");
    }
  }, [uploadLoading]);

  return (
    <div className={`${uploadLoading ? "image-load" : ""}`}>
      {!checkWinner && showUploadBox && !uploadLoading && recognition && (
        <>
          <h2 className="title register-title" style={{ fontWeight: 400 }}>
            Simply click the button below to scan your Coca-Cola and find out if
            you're a winner.
          </h2>
          <label className="w-100">
            <div className="upload-box">
              <input
                type="file"
                hidden
                name="image"
                accept=".jpg,.jpeg,.png,.bmp"
                onChange={onFileUpload}
              />
              <img src={uploadIcon} alt="upload" className="upload-icon" />
            </div>
          </label>
        </>
      )}

      {!checkWinner && !showUploadBox && image && (
        <>
          <p className="uploaded-description">
            Your image has successfully uploaded. Please click below to
            continue.
          </p>
          <div className="text-center uploaded">
            <input
              type={"button"}
              alt="uploaded"
              className="remove-icon"
              onClick={removeUploaded}
            />
            <img src={image} alt="uploaded" className="w-100 uploaded-image" />
          </div>
          <div className="text-center">
            <Button className="cc-button upload-btn" onClick={submitForm}>
              Continue
            </Button>
          </div>
        </>
      )}

      {!checkWinner && showUploadBox && !uploadLoading && !recognition && (
        <>
          <h2 className="title scan-title">
            That didn’t seem to work. Please click below to try scanning again.
          </h2>
          <p className="uploaded-description failed">
            Can’t scan a glass or bottle? Please simply scan the Coca-Cola logo
            from the promotional material in outlet.
          </p>
          <label className="w-100">
            <div className="upload-box">
              <input
                type="file"
                hidden
                name="image"
                accept=".jpg,.jpeg,.png,.bmp"
                onChange={onFileUpload}
              />
              <img src={uploadIcon} alt="upload" className="upload-icon" />
            </div>
          </label>
          {/* <p className="uploaded-description failed fw-bold">
            Still having problems?
          </p>
          <p className="uploaded-description feedback">
            Contact{" "}
            <a
              className="mail-feedback"
              href="mailto:wincokemusic@meshmarketing.co.uk"
            >
              wincokemusic@meshmarketing.co.uk
            </a>{" "}
            for more information
          </p> */}
        </>
      )}

      {!checkWinner && uploadLoading && <div className="loading-spinner" />}

      {checkWinner && (
        <div className="text-center">
          <img
            src={loadingGif}
            alt="loading"
            className="loading-icon "
            width={130}
          />
        </div>
      )}
    </div>
  );
};
